var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCaptivePortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20C21.6044 20 21.2178 20.1173 20.8889 20.3371C20.56 20.5568 20.3036 20.8692 20.1522 21.2346C20.0009 21.6001 19.9613 22.0022 20.0384 22.3902C20.1156 22.7781 20.3061 23.1345 20.5858 23.4142C20.8655 23.6939 21.2219 23.8844 21.6098 23.9616C21.9978 24.0387 22.3999 23.9991 22.7654 23.8478C23.1308 23.6964 23.4432 23.44 23.6629 23.1111C23.8827 22.7822 24 22.3956 24 22C24 21.4696 23.7893 20.9609 23.4142 20.5858C23.0391 20.2107 22.5304 20 22 20Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 18.1797C19.2451 17.4105 20.6069 17 22 17C23.8681 17 25.6596 17.7375 26.9806 19.0502C27.8152 19.8797 28.4187 20.8958 28.75 22C28.5499 22.6669 28.2498 23.304 27.8565 23.889C27.0826 25.0401 25.9825 25.9373 24.6955 26.4672C23.4084 26.997 21.9922 27.1356 20.6259 26.8655C19.2595 26.5954 18.0045 25.9287 17.0194 24.9497C16.1899 24.1254 15.5832 23.1107 15.25 22C15.3189 21.7704 15.3997 21.5439 15.4926 21.3212C16.0257 20.0421 16.9285 18.9488 18.0868 18.1797Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19V15C11 13.8954 11.8954 13 13 13H17.3673",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25V29C11 30.1046 11.8954 31 13 31H17.3673",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19V15C33 13.8954 32.1046 13 31 13H26.6327",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 25V29C33 30.1046 32.1046 31 31 31H26.6327",
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCaptivePortal);
export default __webpack_public_path__ + "static/media/btn_captive_portal.c938e5c6324dd1aa51932fec8ab3f82e.svg";
export { ForwardRef as ReactComponent };